import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import { paths } from '../../routes/paths';

const DemoFab = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(paths.dashboard.demo, { replace: true });
  };

  return (
    <Tooltip title="Try Instant Demo" placement="left">
      <Fab 
        color="primary" 
        aria-label="instant demo"
        onClick={handleClick}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 1000,
        }}
      >
        <AddIcon />
      </Fab>
    </Tooltip>
  );
};

export default DemoFab;